import Socket from '../../utils/webSocketsMiddleware/socketConnection';
import { wsActions } from '../../reducers/websockets';

const connectSocketToServer = () => (dispatch, getState) => {
  const { auth: { token } } = getState();
  Socket.initSocketConnection(token);
};

const subscribeToChannel = channelId => (dispatch) => {
  const { subscribe } = Socket.getSocketConnection();
  if (subscribe) {
    subscribe(channelId);
    dispatch(wsActions.subscribeToChannel({ channelId }));
  }
};

const unsubscribeToChannel = channelId => (dispatch) => {
  const { ws } = Socket.getSocketConnection();
  if (ws) {
    const channel = ws.getSubscription(channelId);
    channel.close();
    channel.on('close', () => {
      dispatch(wsActions.unsubscribeToChannel({ channelId }));
    });
  }
};

const listenEvent = ({ topic, event, action }) => (dispatch) => {
  const { ws } = Socket.getSocketConnection();
  if (ws) {
    const channel = ws.getSubscription(topic);
    //console.log('listen to event', event)
    channel.on(event, (data) => {
      //console.log('event!!!', event, data);
      dispatch(action(data));
    });
  }
};

export {
  listenEvent,
  subscribeToChannel,
  connectSocketToServer,
  unsubscribeToChannel,
};



// WEBPACK FOOTER //
// ./src/reducers/websockets/operations.js